export { getId };
export { getName };
export { quote };
export { req };
export { globalify };

function getId(m) {
	return m.id;
}

function getName(m) {
	return m.name;
}

function quote(str) {
	return "'" + JSON.stringify(str).slice(1, -1).replace(/'/g, "\\'") + "'";
}

function req(path) {
	return "require(" + quote(path) + ")";
}

function globalify(name) {
	if (/^__dep\d+__$/.test(name)) {
		return 'undefined';
	} else {
		return "global." + name;
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/mappers.js.01-babel.map